// src/project/data/fetches/packages.js
import { buildUrlWithAuth, RIDER_ENDPOINTS } from '../config/apiConfig'
import parseExternalDelivery from '../scripts/parseExternalDelivery'
import Storage from '@/shared/utils/storage'

export default {
  url(payload) {
    console.log("🚀 ~ payload packages:", payload)
    // Récupérer les colis en cours pour le livreur (ex: 'assigned,picked_up') ou en attente si non assigné
    const params = { status: 'confirmed,assigned,picked_up,in_transit,at_checkpoint', pendingOrder: 'true' }

    const riderLocation = Storage.get('userData')?.location
    if (riderLocation?.latitude && riderLocation?.longitude) {
      params.lat = riderLocation.latitude
      params.lng = riderLocation.longitude
    }

    return buildUrlWithAuth(RIDER_ENDPOINTS.PACKAGE_LIST, params)
  },
  parse(raw = {}) {
    if (raw?.statusCode === 404) {
      return {
        statusCode: 200,
        message: 'Empty',
        data: [],
      }
    }
    if (raw?.statusCode !== 200 && !raw?.data) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Échec de connexion au serveur',
        data: null,
      }
    }

    const deliveries = Array.isArray(raw?.data?.data)
      ? raw.data.data
      : Array.isArray(raw?.data?.items)
        ? raw.data.items
        : Array.isArray(raw?.data)
          ? raw.data
          : []

    return {
      statusCode: 200,
      message: 'Ok',
      data: deliveries.map(d => parseExternalDelivery(d)).filter(Boolean),
    }
  },
}
